import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mediaTitle' })

export class MediaTitlePipe implements PipeTransform {

    transform(input: string, video): string {
        const text = '上次播放到';
        const arr = ['tv-series', 'anime', 'variety'];
        if (!arr.includes(video.category)) {
            return text;
        }
        if (!parseInt(input, 0)) {
            return text;
        }
        // return text + '第<span class="text-red mr-1 ml-1"><b>' + parseInt(input, 0) + '</b></span>集';
        return text + '第<span class="text-red mr-1 ml-1"><b>' + input + '</b></span>集';

    }
}

@Pipe({ name: 'decodeQuery' })
export class DecodeQueryPipe implements PipeTransform {

    transform(input: string): string {

        return decodeURIComponent(input);
    }
}



@Pipe({ name: 'commaToArray' })
export class CommaToArray implements PipeTransform {

    transform(input: string): string[] {
        return !!input ? input.split(',') : [];
    }
}

@Pipe({ name: 'commaToString' })
export class CommaToString implements PipeTransform {

    transform(input: string): string {
        if (!!input !== null) {
            return input.replace(/,/g, ' / ');
        }
        return '';
    }
}